import React from 'react'
import ClientMasterClassSetting from '../../client/MasterClass'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientMasterClassPage() {
  return (
    <V3ProfileRouteShell>
      <ClientMasterClassSetting />
    </V3ProfileRouteShell>
  )
}

